module.exports = require("./kde-TZ.js");